import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ActivitySlider.css';
import ModalTrigger from '../../../shared/modal/ModalTrigger';

type ActivitySliderProps = {
  assessmentValues: any;
  leftlabel: string;
  modalText: string;
  questionid: string;
  questionTitle: string;
  rightlabel: string;
  width: string;
  onOpenModal: () => void;
  onSetValue: ({ id, value }: { id: string; value: any }) => void;
};

export function ActivitySlider({
  assessmentValues,
  leftlabel,
  modalText,
  questionid,
  questionTitle,
  rightlabel,
  width,
  onOpenModal,
  onSetValue,
}: ActivitySliderProps) {
  const { t } = useTranslation();

  const [textValue, setTextValue] = useState(t('A118'));
  const [rangeValue, setRangeValue] = useState('0');

  useEffect(() => {
    if (assessmentValues[questionid]) {
      setTextValue(assessmentValues[questionid].textValue);
      setRangeValue((assessmentValues[questionid].value / 15).toString());
    } else {
      setTextValue(t('A118'));
      onSetValue({
        id: questionid,
        value: {
          textValue: t('A118'),
          value: '0',
        },
      });
    }
  }, [assessmentValues, questionid]);

  const handleRangeChange = (event) => {
    const { value } = event.target;
    const minValue = Number(value) * 15;
    setRangeValue(event.target.value);
    const mins = minValue;
    const hours = Math.floor(mins / 60);
    let textMessage;

    if (hours > 0) {
      const minutes = mins - hours * 60;
      textMessage = `${hours} ${t('A119')} ${minutes} ${t('A120')}`;
    } else {
      const minutes = mins;
      textMessage = `${minutes} ${t('A120')}`;
    }

    setTextValue(textMessage);

    const item = {
      textValue: textMessage,
      value: minValue.toString(),
    };

    onSetValue({ id: questionid, value: item });
  };

  return (
    <div className={`req question_block${width} activity_slider_container`}>
      <fieldset id={questionid} data-input-type="activity-slider">
        <legend className="assessment_question_title">{questionTitle}</legend>
        {modalText && (
          <ModalTrigger
            modalText={modalText}
            onOpenModal={onOpenModal}
            question={questionid}
            questionTitle={questionTitle}
          />
        )}
        <div className="answer_block fs-exclude">
          <div className="activitySlider" id={questionid}>
            <div className="leftLabel">{leftlabel}</div>
            <div className="rightLabel">{rightlabel}</div>
            <div className={`range-container value-${rangeValue}`}>
              <input
                type="range"
                min={0}
                max={40}
                value={rangeValue}
                onChange={handleRangeChange}
                id={`${questionid}_slider`}
                aria-valuetext={textValue}
                aria-label={`${questionTitle} ${t('slider.description.from')} ${leftlabel} ${t('slider.description.to')} ${rightlabel}`}
                data-uw-ignore-s3
              />
            </div>
            <label
              className="valueHandle"
              id={`${questionid}_value_handle`}
              htmlFor={`${questionid}_slider`}
            >
              {textValue}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  );
}
